import { GET, PATCH, POST, DELETE } from '../common/common.service'
import endpointsCompanies from './endpoints'

const CompaniesService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsCompanies.LOAD(filter, sort, limit, skip)),
  getById: async (id) => GET(endpointsCompanies.BY_ID(id)),
  create: async (body) => POST(endpointsCompanies.CREATE, body),
  update: async ({ _id, body }) => PATCH(endpointsCompanies.UPDATE(_id), body),
  remove: async (id) => DELETE(endpointsCompanies.REMOVE(id)),
}

export default CompaniesService
